import { render, staticRenderFns } from "./MediaPreview.vue?vue&type=template&id=311e5b26"
import script from "./MediaPreview.vue?vue&type=script&lang=ts"
export * from "./MediaPreview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseBtn: require('/builds/medtochka/medtochka-frontend/core/components/Base/BaseBtn.vue').default,BaseImg: require('/builds/medtochka/medtochka-frontend/core/components/Base/BaseImg.vue').default})
